<template>
    <div class="login-container">
        <el-form
            ref="rForm"
            :model="rForm"
            :rules="rRules"
            class="login-form"
            auto-complete="on"
            label-position="left"
        >
            <!-- <p class="stystem_title">上海市书法家协会征稿系统</p> -->
            <div class="c-flex-ajcenter title_box">
                <h3 class="title">{{ $t('login.register') }}</h3>
                <LangSelect class="lang" />
            </div>
            <el-form-item prop="mobile">
                <el-input
                    v-model="rForm.mobile"
                    name="mobile"
                    type="text"
                    auto-complete="on"
                    :placeholder="$t('login.mobile')"
                    @input="bindKeyMobile"
                >
                    <i slot="prefix" class="el-icon el-icon-mobile-phone" />
                </el-input>
            </el-form-item>

            <el-form-item prop="password">
                <el-input
                    v-model="rForm.password"
                    :type="pwdType"
                    name="password"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('login.password')"
                    @keyup.enter.native="submit"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="password">
                <el-input
                    v-model="rForm.password_confirmation"
                    :type="pwdType"
                    name="password_confirmation"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('login.confirmPwd')"
                    @keyup.enter.native="submit"
                >
                    <i slot="prefix" class="el-icon el-icon-lock" />
                    <i slot="suffix" class="el-icon el-icon-view" :class="{'el-icon-view-actived':!pwdType}" @click="showPwd" />
                </el-input>
            </el-form-item>

            <el-form-item prop="code">
                <div class="form-item">
                    <el-input
                        v-model="rForm.code"
                        name="code"
                        autocomplete="on"
                        auto-complete="off"
                        :placeholder="$t('login.verificationCode')"
                        clearable
                        style="width: 60%;"
                    />
                    <el-button size="small" type="primary" :class="{'disabledBtn':codeBtn}" @click="getCode">{{ codeName }}</el-button>
                </div>
            </el-form-item>

            <el-form-item>
                <el-button
                    class="login-btn"
                    :loading="loading"
                    size="medium"
                    type="primary"
                    style="width:100%;"
                    @click.native.prevent="submit"
                >{{ $t('login.register') }}</el-button>
            </el-form-item>
            <div class="other">
                <p @click="hancleChangeType('login')">{{ $t('login.loginIn') }}</p>
                |
                <!-- <p @click="hancleChangeType('password')">修改密码</p>
                | -->
                <p @click="hancleChangeType('reset')">{{ $t('login.reset') }}</p>
            </div>
        </el-form>
    </div>
</template>

<script>
import LangSelect from '@/components/LangSelect'
import mix_user from '../mix_user'

export default {
    name: 'Register',
    mixins: [mix_user],
    components: { LangSelect },
    data() {
        return {
            rForm: {
                mobile: '',
                password: '',
                password_confirmation: '',
                code: ''
            }
        }
    },
    methods: {
        submit() {
            this.$refs['rForm'].validate((valid) => {
                if (valid) {
                    this.$emit('submit', this.rForm)
                }
            })
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
@import '../../../styles/login';
@import '../../../styles/variables';
.login-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background: url('../../../assets/images/bg.png') no-repeat;
  background-size: 100% 100%;

  .login-form {

    .form-item{
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/ .el-input--mini .el-input__inner{
        padding-left: 20px;
      }

      /deep/ .el-button{
        font-size: 14px;
        padding: 8px 20px;
        line-height: inherit;
        box-shadow: 2px 3px 10px 0px $white;
      }

      .disabledBtn{
        background: #ccc;
        border-color: #ccc;
      }
    }
  }
}
</style>
